import { render, staticRenderFns } from "./Emoticons.vue?vue&type=template&id=35226b82&scoped=true&"
import script from "./Emoticons.vue?vue&type=script&lang=ts&"
export * from "./Emoticons.vue?vue&type=script&lang=ts&"
import style0 from "./Emoticons.vue?vue&type=style&index=0&id=35226b82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35226b82",
  null
  
)

export default component.exports